'use client';

import { useState } from 'react';
import BrandDefinition from '@/types/BrandDefinition';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import MenuIcon from '@mui/icons-material/Menu';
import HeaderNavigationItem from '../HeaderNavigationItem';
import HeaderDrawer from '../HeaderDrawer';
import HeaderSearch from '../HeaderSearch';

interface HeaderMobileMenuProps {
	pages: { id: string; title: string; url: string }[];
	searchPlaceholder: string;
	brand: BrandDefinition;
}

export default function HeaderMobileMenu({ pages, searchPlaceholder, brand }: Readonly<HeaderMobileMenuProps>) {
	const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

	const theme = useTheme();
	const isMobileOrTablet = useMediaQuery(theme.breakpoints.down('md'));

	const toggleMobileMenu = (open: boolean) => () => {
		setMobileMenuOpen(open);
	};

	return (
		isMobileOrTablet && (
			<Box sx={{ mr: { xs: 'auto', md: '0' }, pr: '37px', display: { xs: 'flex', md: 'none' } }}>
				<IconButton
					edge="start"
					aria-label="menu"
					data-testid="header-mobile-button"
					onClick={toggleMobileMenu(true)}
					sx={{ p: '3px', m: '0' }}
				>
					<MenuIcon sx={{ color: 'black.main' }} />
				</IconButton>
				<HeaderDrawer open={mobileMenuOpen} onClose={toggleMobileMenu(false)} brand={brand}>
					<HeaderSearch placeholderLabel={searchPlaceholder} onSearch={toggleMobileMenu(false)} />
					<Box sx={{ mt: '10px' }}>
						{pages.map((page) => (
							<HeaderNavigationItem
								onClick={toggleMobileMenu(false)}
								key={page.id}
								url={page.url}
								title={page.title}
								data-testid="header-mobile-navigation-item"
							/>
						))}
					</Box>
				</HeaderDrawer>
			</Box>
		)
	);
}
